<template>
  <div>
    <section v-for="(category, i) in categories" :key="i">
      <div class="content-suggestion" v-for="(sub, k) in category.subfamilies" :key="k">
        <div class="content-suggestion-header">
          <div class="container">
            <div class="content-suggestion-header-title">
              <h2>
                {{ category.name }} <span>{{ sub.name }}</span>
              </h2>
            </div>
            <template v-if="$route && $route.name === 'HomeStore'">
              <a class="content-suggestion-header-btn" @click="sendFilter(sub.slug, category.slug)">
                {{ $t('pages.product.more') }}
              </a>
            </template>
          </div>
        </div>
        <div class="content-suggestion-body">
          <div class="container">
            <swiper :options="swiperProducts" class="content-suggestion-grid">
              <swiper-slide v-for="(prod, n) in sub.products" :key="n">
                <CardProduct :product="prod" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <template v-if="$route && $route.name === 'PartnerLandingPage'">
          <div class="content-suggestion-btn">
            <div class="container">
              <router-link class="content-suggestion-btn-link" tag="a" to="/home-store">
                {{ $t('pages.product.store') }}
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import CardProduct from "@/components/cards/CardProduct.vue";

export default {
  data() {
    return {
      swiperProducts: {
        slidesPerView: 1.4,
        spaceBetween: 20,
        speed: 800,
        watchOverflow: true,
        clickable: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.6,
          },
          992: {
            slidesPerView: 4,
          },
        },
      },
    };
  },
  methods: {
    sendFilter(subfamily, family) {
      this.$store.dispatch("Products/FilterStore/setFilterList", {
        subfamily: subfamily,
      });

      // if you don't care about the navigation failing, you should catch it by using this:
      this.$router
        .push({
          name: "CategoriesStore",
          params: {
            slug: this.slug,
            family: family,
          },
        })
        .catch(() => { });
    },
  },
  directives: {
    swiper: directive,
  },
  props: ["categories", "slug"],
  components: {
    Swiper,
    SwiperSlide,
    CardProduct,
  },
};
</script>

<style lang="scss">
.content-suggestion {
  padding: 30px 0px;

  &-header {
    margin-bottom: 30px;

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-title {
      text-align: left;

      h2 {
        font-family: "Font Regular";
        font-size: 25px;
        color: var(--green-dark);
        margin-bottom: 0;

        span {
          display: block;
          font-family: "Font Bold";
          font-size: 35px;
          color: var(--green-medium);
        }
      }
    }

    &-btn {
      width: 115px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--white);
      border: 1px solid var(--green-medium);
      border-radius: 10px;
      font-size: 18px;
      font-family: "Font Regular";
      color: var(--green-medium);
      transition: 500ms;

      @media (max-width: 991px) {
        width: 90px;
        height: 35px;
        font-size: 16px;
      }

      &:hover,
      &:focus {
        cursor: pointer;
        background: var(--green-medium);
        color: var(--white);
      }
    }
  }

  &-body {
    @media (max-width: 991px) {
      .container {
        padding-right: 0;
      }
    }

    .swiper-container {
      .swiper-slide {
        .content-sugestion-grid-item {
          margin-bottom: 0;
        }
      }
    }
  }

  &-btn {
    margin-top: 45px;

    &-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 194px;
      height: 72px;
      background-color: var(--green-medium);
      border: 1px solid var(--green-medium);
      border-radius: 10px;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
      font-size: 25px;
      font-family: "Font Regular";
      color: var(--white);
      margin: 0 auto;
      transition: 500ms;

      &:hover,
      &:focus {
        background: var(--white);
        color: var(--green-medium);
      }
    }
  }
}
</style>
